export interface NotificationData {
  id: string;
  name: string;
  image: string;
  message: string;
}

const notificationData: NotificationData[] = [];
export default notificationData;
